export default __webpack_public_path__ + "static/media/Gil_Rabbi.58edcedf.jpg";